import { platformInfo } from '@gem/utils';

import { Platform } from 'APP/wsApi/wsAppApi/types/common/common_model_pb';
import Entities from 'STORE';
import { getUserLanguage } from 'UTILS/getUserLanguage';

import { ILoginDeviceInfo } from './login.types';

export function getDeviceInfoForLogin(): ILoginDeviceInfo {
  return {
    deviceId: platformInfo.deviceId,
    platform: Platform.WEB,
    device: platformInfo.device,
    osName: platformInfo.osName,
    osVersion: platformInfo.osVersion,
    appVersion: Entities.App.version,
    locale: getUserLanguage(),
  };
}
